"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import s from "underscore.string";
import React from "react";
import $ from "jquery";
import _ from "underscore";
import Api from "../api/api";
import ApiService from "../services/api_service";
import Auth from "../util/auth";
import Blocker from "./blocker";
import CarrierSetter from "./carrier_setter";
import CarrierService from "../services/carrier_service";
import ClientNotesSidebar, {
  ClientNotesSidebarTrigger
} from "./indexer/client_notes_sidebar";
import DocumentBrowser from "./react_document_browser";
import "./indexer/email_viewer";
import EmailHelper from "../helpers/email_message";
import ExceptionSender from "./exception_sender";
import IndexerHeader from "./indexer/indexer_header";
import "./indexer/load_detail_information";
import MarkEmailCompleteView from "./mark_email_complete_view";
import moment from "moment";
import PresenceList from "./presence";
import ToDashboardWithFilters from "./ui/to_dashboard_with_filters";
import { EmailForwarder } from "./email_forwarder";
import { NoDocumentsProgressBar } from "./progress_bars";
import { push } from "./app_history";
import {
  GroupedDocumentBrowserModel,
  DocumentBatchGroupCreator
} from "./grouped_document_browser_model";
function isSidebarFeatureEnabled() {
  const settings = Api.Account.currentSettings();
  if (!settings) return false;
  const setting = settings["client_notes_sidebar_display"];
  return setting && setting !== "disabled";
}
function documentFromEmail(emailMessage) {
  return ApiService.addErrorHandler(
    // TODO: use fetch instead
    // eslint-disable-next-line no-restricted-syntax
    $.post("/api/email_messages/" + emailMessage.id + "/create_document"),
    null,
    { caller: "EmailWithoutDocuments.documentFromEmail" }
  );
}
function exceptionsSignature() {
  return Auth.getCurrentUser().settings["exceptions_signature"] || "";
}
function quotedBody(email, signature) {
  var whiteSpace = "\n\n";
  var prefix = "\n\nat " + moment(email.created_at).format("LLL") + email.sender_address + " wrote:\n";
  return whiteSpace + signature + prefix + _.map(s.lines(email.text_body), function(line) {
    return "> " + line;
  }).join("\n");
}
function isReceivablesEmail(email) {
  function isReceivablesLabel(label) {
    return label.name == "Receivables";
  }
  return email.labels.some(isReceivablesLabel);
}
function possibleProcessOriginal(props) {
  if (props.documentGroup) {
    return /* @__PURE__ */ jsx(
      "a",
      {
        href: "/app/index-document-batches/" + props.documentGroup.document_batch_id + "?group_id=" + props.documentGroup.id,
        className: "button button--confirmation",
        children: "Process Original Documents"
      }
    );
  }
}
function documentFromEmailCallback(props, data) {
  const newLocation = props.location.query.onDone || "/dashboard";
  push("/index-document-batches/" + data.document_batch.id, {
    onDone: newLocation
  });
}
function possibleMessageBrowserComponent(props, onDocumentFromEmail) {
  const email = props.email;
  const emails = props.email && _.sortBy(
    email.parent_emails.concat(email.replies).concat(email),
    "created_at"
  ).reverse();
  if (emails.length > 0) {
    return {
      label: "Messages",
      component: EmailHelper.emailMessages(
        emails,
        documentFromEmail,
        onDocumentFromEmail
      )
    };
  }
}
function additionalBrowserComponents(props, onDocumentFromEmail) {
  return [possibleMessageBrowserComponent(props, onDocumentFromEmail)].filter(
    (component) => component !== void 0
  );
}
function doneMarkingComplete(props) {
  ToDashboardWithFilters(props.location);
}
class EmailWithoutDocuments extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "loadCarrierData", () => {
      var _a, _b, _c, _d, _e;
      const carrierId = ((_a = this.props.email) == null ? void 0 : _a.carrier_id) || ((_c = (_b = this.props.email) == null ? void 0 : _b.carrier) == null ? void 0 : _c.id) || ((_d = this.props.carrier) == null ? void 0 : _d.id) || ((_e = this.props.email) == null ? void 0 : _e.document_batch_carrier_id);
      if (carrierId && isSidebarFeatureEnabled()) {
        CarrierService.carrierWithId(carrierId).then((fullCarrier) => {
          this.setState({ carrierData: fullCarrier });
        });
      }
    });
    __publicField(this, "handleToggleSidebar", () => {
      this.setState((prevState) => ({ sidebarOpen: !prevState.sidebarOpen }));
    });
    __publicField(this, "renderSidebar", () => {
      var _a;
      if (!isSidebarFeatureEnabled() || !this.state.carrierData) {
        return null;
      }
      return /* @__PURE__ */ jsx(
        ClientNotesSidebar,
        {
          warning: this.state.carrierData.warning || null,
          notes: this.state.carrierData.notes || null,
          fundingNotes: this.state.carrierData.funding_notes || null,
          verificationInstructions: this.state.carrierData.verification_instructions || null,
          isOpen: this.state.sidebarOpen,
          onToggle: this.handleToggleSidebar,
          loading: false,
          noteSettings: Api.Account.currentSettings()["client_notes_configuration"]
        },
        ((_a = this.state.carrierData) == null ? void 0 : _a.id) || "sidebar"
      );
    });
    __publicField(this, "renderSidebarTrigger", () => {
      if (!isSidebarFeatureEnabled() || !this.state.carrierData) {
        return null;
      }
      return /* @__PURE__ */ jsx(
        ClientNotesSidebarTrigger,
        {
          warning: this.state.carrierData.warning || null,
          notes: this.state.carrierData.notes || null,
          fundingNotes: this.state.carrierData.funding_notes || null,
          verificationInstructions: this.state.carrierData.verification_instructions || null,
          onToggle: this.handleToggleSidebar,
          noteSettings: Api.Account.currentSettings()["client_notes_configuration"]
        }
      );
    });
    __publicField(this, "emailChainViewer", () => {
      return /* @__PURE__ */ jsx(
        DocumentBrowser,
        {
          model: this.documentModel,
          additionalComponents: additionalBrowserComponents(
            this.props,
            (data) => documentFromEmailCallback(this.props, data)
          ),
          location: this.props.location
        }
      );
    });
    // The email has no documents; the browser is here for its Messages tab.
    __publicField(this, "documentModel", new GroupedDocumentBrowserModel(
      DocumentBatchGroupCreator([], () => false)
    ));
    __publicField(this, "startSetCarrier", () => {
      this.setState({ step: 0, forcedStep: true });
    });
    __publicField(this, "carrierSetterComplete", (e) => {
      this.props.carrierSetter.onSetCarrier(e).then((result) => {
        this.setState({ step: 1 });
      });
    });
    __publicField(this, "carrierSetterOrReply", () => {
      if (this.state.step === 0) {
        return /* @__PURE__ */ jsx(
          CarrierSetter,
          {
            isReceivablesEmail: isReceivablesEmail(this.props.email),
            onSetCarrier: this.carrierSetterComplete,
            carrier: this.props.carrier || {},
            isSingleCarrier: this.props.email.single_carrier
          }
        );
      } else {
        return /* @__PURE__ */ jsxs("div", { className: "reply-view__body", children: [
          /* @__PURE__ */ jsxs("div", { className: "reply-view__header", children: [
            /* @__PURE__ */ jsxs("div", { className: "reply-view__header-row", children: [
              /* @__PURE__ */ jsx("p", { className: "reply-view__instructions", children: "No documents were found on this email. You can either reply to this message or ignore this entry." }),
              possibleProcessOriginal(this.props)
            ] }),
            /* @__PURE__ */ jsx("h3", { className: "reply-view__section-title", children: "Send a Reply" })
          ] }),
          /* @__PURE__ */ jsx(
            ExceptionSender,
            {
              onComplete: this.props.returningMethods.onComplete,
              defaultEmail: {
                body: quotedBody(this.props.email, exceptionsSignature()),
                subject: "Re: " + this.props.email.subject
              },
              markParentComplete: true,
              emailMessageId: this.props.email.id,
              parent: this.props.email
            }
          )
        ] });
      }
    });
    __publicField(this, "forwardingCanceled", () => {
      this.setState({ forwardingEmail: false });
    });
    __publicField(this, "forwardingDone", (completed) => {
      this.forwardingCanceled();
      if (completed) {
        ToDashboardWithFilters(this.props.location);
      }
    });
    __publicField(this, "forwardEmail", () => {
      this.setState({ forwardingEmail: true });
    });
    __publicField(this, "possibleEmailForwarder", (email) => {
      if (this.state.forwardingEmail) {
        return /* @__PURE__ */ jsx(
          EmailForwarder,
          {
            email,
            onCancel: this.forwardingCanceled,
            onDone: this.forwardingDone
          }
        );
      }
    });
    __publicField(this, "cancelMarkingComplete", () => {
      this.setState({ markingComplete: false });
    });
    __publicField(this, "startMarkingComplete", (email) => {
      this.setState({ markingComplete: true });
    });
    __publicField(this, "possibleMarkComplete", (email) => {
      if (this.state.markingComplete) {
        return /* @__PURE__ */ jsx(
          MarkEmailCompleteView,
          {
            email,
            onCancel: this.cancelMarkingComplete,
            onMarkCompleteFinished: () => doneMarkingComplete(this.props)
          }
        );
      }
    });
    const settings = Api.Account.currentSettings();
    const setting = settings ? settings["client_notes_sidebar_display"] : void 0;
    const initialSidebarOpen = setting === "expanded";
    this.state = {
      step: !props.email.document_batch_carrier_id && _.isNull(props.email.single_carrier) ? 0 : 1,
      sidebarOpen: initialSidebarOpen,
      carrierData: null
    };
  }
  componentDidMount() {
    this.loadCarrierData();
  }
  componentDidUpdate(prevProps) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
    if (((_a = this.props.email) == null ? void 0 : _a.carrier_id) !== ((_b = prevProps.email) == null ? void 0 : _b.carrier_id) || ((_d = (_c = this.props.email) == null ? void 0 : _c.carrier) == null ? void 0 : _d.id) !== ((_f = (_e = prevProps.email) == null ? void 0 : _e.carrier) == null ? void 0 : _f.id) || ((_g = this.props.carrier) == null ? void 0 : _g.id) !== ((_h = prevProps.carrier) == null ? void 0 : _h.id) || ((_i = this.props.email) == null ? void 0 : _i.document_batch_carrier_id) !== ((_j = prevProps.email) == null ? void 0 : _j.document_batch_carrier_id)) {
      this.loadCarrierData();
    }
  }
  render() {
    return /* @__PURE__ */ jsx(
      Blocker,
      {
        "data-component": "EmailWithoutDocuments",
        modalView: this.possibleEmailForwarder(this.props.email) || this.possibleMarkComplete(this.props.email),
        children: /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsx("div", { className: "document-indexer__header", children: /* @__PURE__ */ jsx(
            IndexerHeader,
            {
              email: this.props.email,
              carrier: this.props.email.carrier,
              canSetCarrier: this.state.step === 1,
              setCarrier: this.startSetCarrier,
              canMarkComplete: true,
              markComplete: this.startMarkingComplete,
              actions: [["Forward Email", this.forwardEmail]]
            }
          ) }),
          /* @__PURE__ */ jsx(
            NoDocumentsProgressBar,
            {
              stepNumber: this.state.step,
              sidebarTrigger: this.renderSidebarTrigger()
            }
          ),
          /* @__PURE__ */ jsxs("div", { className: "document-indexer__main-body", children: [
            this.renderSidebar(),
            /* @__PURE__ */ jsxs("div", { className: "reply-view__main-body row", children: [
              /* @__PURE__ */ jsxs("div", { className: "small-5 column reply-view__work-area", children: [
                this.carrierSetterOrReply(),
                "\xA0"
              ] }),
              /* @__PURE__ */ jsx("div", { className: "small-5 column reply-view__document-browser", children: this.emailChainViewer() }),
              /* @__PURE__ */ jsx("div", { id: "presence", children: /* @__PURE__ */ jsx(
                PresenceList,
                {
                  location: this.props.location,
                  emailId: this.props.email.id
                }
              ) })
            ] })
          ] })
        ] })
      }
    );
  }
}
export { EmailWithoutDocuments };
